/**
 * @desc 查询合作企业详情
 */
import { BrandEntity } from '@eastcoal/api/content/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryBrandParameter = {
  id?: string
}

const method = 'GET'
const url = '/content/operation/brand'

export const queryBrandApi = (
  params?: QueryBrandParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<BrandEntity>({
    method,
    url,
    params,
    ...config
  })
}

queryBrandApi.method = method
queryBrandApi.url = url
